import { Search, X } from "react-feather";
import styles from "./SearchInput.module.scss";

export const SearchInput = ({ onSearchHandler, value, showCross = false, placeholder = "Type to search", size = "small", type = "text" }) => {
  return (
    <div className="d-flex mb-3">
      <span className={styles.bookmarkSearchContainer}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="w-100 d-flex align-items-center">
            <span className={styles.bookmarkSearchIconContainer}>
              <Search size={14} color="#101828" />
            </span>
            <input value={value} type={type} onChange={(e) => onSearchHandler(e.target.value)} className={size === "medium" ? styles.bookmarkSearchMedium : styles.bookmarkSearch} placeholder={placeholder} />
          </div>
          {showCross && <X size={14} className="mr-1 cursor-pointer" onClick={() => onSearchHandler("cross")} />}
        </div>
      </span>
    </div>
  );
};
